<template>
  <div class="area background">
    <div class="text">
      <h2>Data prediction</h2>
      <h3>
        That's it, our
        <span @mouseover="showInfo = true" @mouseleave="showInfo = false"
          >model<span class="star">*</span></span
        >
        will now analyze your data!
      </h3>
      <h4>
        Depending on the current traffic and the size of your video files, it
        may take a few minutes for the predictions to be processed. <br />Thank
        you for your patience!
      </h4>
      <div class="progress">
        <ul id="example-1">
          <li v-for="video in videos" :key="video.id">
            <span class="table">
              {{ video.name }}; Status: {{ video.prediction.status }}
            </span>
            <span v-if="video.prediction.status !== 'finished'"
              >; Time remaining: {{ video.prediction.timeRemaining }} min</span
            >
            <a
              class="table"
              v-bind:href="video.prediction.CSVUrl"
              target="_blank"
              v-if="video.prediction.status === 'finished'"
            >
              <img src="../../assets/img/csv-icon.png" class="icon" alt="" />
            </a>
            <a
              class="table"
              v-bind:href="video.prediction.annotatedVideoUrl"
              target="_blank"
              v-if="video.prediction.status === 'finished'"
            >
              <img src="../../assets/img/video-icon.png" class="icon" alt="" />
            </a>
            <md-progress-bar
              class="md-custom bar"
              :md-value="parseInt(video.prediction.progress)"
            ></md-progress-bar>
          </li>
        </ul>
      </div>
      <div>
        <a v-bind:href="zipUrl" v-if="allFinished === true">
          <button class="download-button">
            Download results
          </button>
        </a>
      </div>
      <h4 v-if="showInfo === true" class="info"></h4>
      <h4 v-if="showInfo === true">
        <span class="star">*</span>Currently running model: deepMTJ - Leitner et
        al. (2021)
      </h4>
    </div>
  </div>
</template>

<script>
import $ from "jquery";

export default {
  name: "PredictionViewer",
  components: {},
  props: [
    "userID",
    "region",
    "project",
    "videos",
    "croppingWindow",
    "predictionParams"
  ],
  data() {
    return {
      predictionPercentage: 87,
      preprocessingPercentage: 3,
      CSVPercentage: 3,
      videoAnnotationPercentage: 7,
      enablePrediction: true,
      zipUrl: "",
      videosPredicted: 0,
      allFinished: false,
      showInfo: false
    };
  },
  computed: {},
  methods: {
    report_prediction() {
      this.$gtag.event("predict_video", { method: "Google" });
    },
    report_finish() {
      this.$gtag.event("finish_prediction", { method: "Google" });
    },
    async computeAllResults() {
      for (let video of this.videos) {
        if (video.prediction.status !== "finished") {
          video.prediction = {
            progress: 0,
            timeRemaining: "--",
            responseList: [],
            responseListIsCreated: false,
            status: "",
            CSVUrl: "",
            annotatedVideoUrl: "",
            frameList: [],
            numFrames: 0,
            framerate: null
          };
          this.computeResults(video);
        }
      }
    },
    async computeResults(video) {
      if (!video.prediction.responseListIsCreated) {
        video.prediction.status = "preprocess video";
        await this.generateFrames(video);
        video.prediction.status = "predict frames";
        let updateInterval = 15; // in predictions
        let percentage = 0;
        let timeElapsed = 0;
        let i = 0;
        let start, end, timeRemaining;
        for (let [idx, frame] of video.prediction.frameList.entries()) {
          i += 1;
          start = new Date();
          await this.predict(video, frame);
          end = new Date();
          percentage =
            (idx / (video.prediction.numFrames - 1)) *
            this.predictionPercentage;
          video.prediction.progress = percentage + this.preprocessingPercentage;
          timeElapsed += end - start;
          if (i >= updateInterval) {
            i = 0;
            timeRemaining = Math.ceil(
              (timeElapsed / (updateInterval * 1000 * 60)) *
                video.prediction.frameList.length *
                ((100 - video.prediction.progress) / 100)
            );
            timeElapsed = 0;
            video.prediction.timeRemaining = timeRemaining;
          }
          if (this.enablePrediction === false) {
            return "";
          }
        }
        this.$emit("updateResponseListCreated", true);
      }
      video.prediction.status = "create CSV";
      let payload = JSON.stringify(video.prediction.responseList);
      await this.createCSV(video, payload);
      await this.getCSVUrl(video);
      video.prediction.status = "annotate video";
      await this.annotateVideos(video, payload);
      await this.getAnnotatedVideoUrl(video);
      video.prediction.status = "finished";
    },
    generateFrames(video) {
      this.report_prediction();
      return new Promise(resolve => {
        $.get(
          `https://${this.region}-${this.project}.cloudfunctions.net/generate_frames`,
          {
            user_ID: this.userID,
            filename: video.name,
            prediction_rate: this.predictionParams.predictionRate,
            batch_size: 200,
            x: this.croppingWindow.x,
            y: this.croppingWindow.y,
            width: this.croppingWindow.width,
            height: this.croppingWindow.height
          },
          response => {
            let frames = response
              .replace("[", "")
              .replace("]", "")
              .split(" ");
            video.prediction.framerate = parseInt(
              frames[0].slice(1, -1).replace("'", "")
            );
            frames.shift();
            let framesListOneVideo = [];
            for (let frame of frames) {
              frame = frame.slice(1, -1).replace("'", "");
              framesListOneVideo.push(frame);
            }
            video.prediction.frameList = framesListOneVideo;
            video.prediction.numFrames = framesListOneVideo.length;
            video.prediction.progress += this.preprocessingPercentage;
            resolve();
          }
        );
      });
    },
    predict(video, frame) {
      return new Promise(resolve => {
        $.get(
          `https://${this.region}-${this.project}.cloudfunctions.net/predict`,
          {
            user_ID: this.userID,
            filename: video.name,
            frames: frame
          },
          response => {
            let ID = response.slice(1, -1).split(",")[0];
            let num0 = parseFloat(response.slice(1, -1).split(",")[1]);
            let num1 = parseFloat(response.slice(1, -1).split(",")[2]);
            let arr = [ID, num0, num1];
            video.prediction.responseList.push(arr);
            resolve();
          }
        );
      });
    },
    createCSV(video, responseList) {
      return new Promise(resolve => {
        $.post(
          `https://${this.region}-${this.project}.cloudfunctions.net/create_CSV`,
          {
            user_ID: this.userID,
            filename: video.name,
            x: this.croppingWindow.x,
            y: this.croppingWindow.y,
            width: this.croppingWindow.width,
            height: this.croppingWindow.height,
            response_list: responseList
          },
          response => {
            resolve();
          }
        );
      });
    },
    getCSVUrl(video) {
      this.report_finish();
      return new Promise(resolve => {
        $.get(
          "/get_CSV_url",
          {
            user_ID: this.userID,
            filename: video.name + ".csv"
          },
          response => {
            video.prediction.CSVUrl = response;
            video.prediction.CSVCreated = true;
            video.prediction.progress += this.CSVPercentage;
            resolve();
          }
        );
      });
    },
    annotateVideos(video, responseList) {
      return new Promise(resolve => {
        $.post(
          `https://${this.region}-${this.project}.cloudfunctions.net/annotate_video`,
          {
            user_ID: this.userID,
            filename: video.name,
            x: this.croppingWindow.x,
            y: this.croppingWindow.y,
            width: this.croppingWindow.width,
            height: this.croppingWindow.height,
            response_list: responseList,
            prediction_rate: this.predictionParams.predictionRate,
            framerate: video.prediction.framerate
          },
          response => {
            resolve();
          }
        );
      });
    },
    getAnnotatedVideoUrl(video) {
      return new Promise(resolve => {
        $.get(
          "/get_annotated_video_url",
          {
            user_ID: this.userID,
            filename: video.name
          },
          response => {
            video.prediction.annotatedVideoUrl = response;
            video.prediction.videoAnnotated = true;
            video.prediction.progress += this.videoAnnotationPercentage;
            this.videosPredicted += 1;
            if (this.videosPredicted === this.videos.length) {
              this.createZIP();
            }
            resolve();
          }
        );
      });
    },
    createZIP() {
      return new Promise(resolve => {
        let videoList = [];
        for (let video of this.videos) {
          videoList.push(video.name);
        }
        videoList = JSON.stringify(videoList);
        $.post(
          `https://${this.region}-${this.project}.cloudfunctions.net/create_ZIP`,
          {
            user_ID: this.userID,
            video_list: videoList
          },
          response => {
            this.getZIPUrl();
            resolve();
          }
        );
      });
    },
    getZIPUrl() {
      return new Promise(resolve => {
        $.get(
          "/get_zip_url",
          {
            user_ID: this.userID
          },
          response => {
            this.zipUrl = response;
            this.allFinished = true;
            resolve();
          }
        );
      });
    }
  },
  created() {
    let vidlist = [];
    for (let video of this.videos) {
      vidlist.push(video.name);
    }
    this.enablePrediction = true;
    this.computeAllResults();
  },
  destroyed() {
    this.enablePrediction = false;
  }
};
</script>

<style scoped>
.bar {
  min-width: 49vh;
  max-width: 46vw;
}

.progress {
  margin-top: 3vh;
}

.table {
  display: inline;
}
.icon {
  padding-bottom: 5px;
  cursor: pointer;
  width: 35px;
}

.info {
  margin-top: -60px;
}
ul {
  font-size: 12pt;
  list-style-type: none;
  margin: 0;
  padding: 0;
}
a {
  color: black;
}
</style>
